import { Box, color, height, padding } from '@mui/system';
import styled from '@mui/system/styled';

export const SearchListCnt = styled('ul')({
  maxHeight: '300px',
  overflow: 'auto',
});

export const ListItem = styled('li', {
  shouldForwardProp: (prop) => !['selected'].includes(prop),
})(({ selected }) => ({
  display: 'flex',
  marginTop: '5px',
  height: 58,
  alignItems: 'center',
  padding: '10px',
  gap: '10px',
  borderRadius: '10px',
  border: selected ? '1px solid #6868FE' : '1px solid #fff',
  background: selected ? '#EBEAFF' : 'transparent',
  ':hover': {
    cursor: 'pointer',
    background: selected ? '#EBEAFF' : '#F5F5F5',
  },
  '& .textCnt': {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    '& .title': {
      fontSize: '14px',
      fontWeight: selected ? 700 : 600,
      margin: 0,
      color: '#000000',
    },
  },
  '& .selectedItems': {
    fontWeight: 600,
    fontSize: 12,
    color: '#4E48FA',
    background: '#EBEAFF',
    border: '1px solid #8486FF',
    borderRadius: 60,
    padding: '6px 10px',
  },
}));
